<form *ngIf="! configs['isGrid']" [formGroup]="formGroup">
    <ng-select 
        [items]="datasource"
        [bindLabel]="configs['displayField']"
        [virtualScroll]="configs['enableVirtualScroll']"
        notFoundText="No data found"
        [selectOnTab]="true"
        appendTo="body"
        [formControlName]="configs['id']"
        placeholder="{{configs['placeholder']}}"
        [groupBy] = "configs['groupBy']"
        (change)="onSuggestionSelected($event)"
        (scroll)="onScroll($event)"
        (scrollToEnd)="onScrollToEnd()"
        [readonly]="!!configs['isReadOnly']">
            <ng-template *ngIf="configs['enableVirtualScroll']" ng-header-tmp>
                <small class="form-text text-muted">Loaded {{filterdData.length}} of {{datasource.length}}</small>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
                {{item[configs['displayField']]}}
            </ng-template>
        </ng-select>
</form>
<div *ngIf="configs['isGrid']">
    <ng-select 
        [id]="configs['id']" 
        [items]="datasource"
        [bindLabel]="configs['displayField']"
        placeholder="{{configs['placeholder']}}"
        [virtualScroll]="configs['enableVirtualScroll']"
        notFoundText="No data found"
        [selectOnTab]="true"
        appendTo="body"
        [(ngModel)]="configs['model']"
        [multiple]="configs['canMultiselect']"
        [maxSelectedItems]="50"
        [clearable]="true"
        (change)="onSuggestionSelected($event)"
        (scroll)="onScroll($event)"
        (scrollToEnd)="onScrollToEnd()"
        (clear)="onClearText($event)">
            <ng-template *ngIf="configs['enableVirtualScroll']" ng-header-tmp>
                <small class="form-text text-muted">Loaded {{filterdData.length}} of {{datasource.length}}</small>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
                {{item.value}}
            </ng-template>
        </ng-select>
</div>